import { Button, message } from 'antd';
import { isEmpty } from 'lodash';
import React from 'react';
import PhotosViewer from '../../components/PhotosViewer/PhotosViewer';
import BookingApi from '../../functions/api/booking/BookingApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import UserApi from '../../functions/api/user/UserApi';

const PROCEDURE_STATUS_BASIC = 1;
const PROCEDURE_STATUS_FULL = 2;

export default class BookingViewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isDisabled: true,
      detailBookingImg: [],
    };
    this.toggle = this.toggle.bind(this);
  }

  async toggle() {
    const booking = this.props.record;
    let images;
    let isDisabled = true;

    if (!booking.user_acc_id) {
      const { bookingImages } = await BookingApi.getBookingByCode(
        booking.book_code
      );
      images = await this.convertToViewerFormat(bookingImages);
    } else {
      const userImages = await UserApi.getImagesByUserId(booking.user_acc_id);
      images = await this.convertToViewerFormat(userImages);
      const user = await UserApi.getUserById(booking.user_acc_id, false);

      if (
        !isEmpty(user.data) &&
        user.data.procedure_status &&
        (PROCEDURE_STATUS_BASIC === user.data.procedure_status ||
          PROCEDURE_STATUS_FULL === user.data.procedure_status)
      ) {
        isDisabled = false;
      }
    }

    if (isEmpty(images)) {
      message.error('Người dùng chưa upload hồ sơ');
      return;
    }

    this.setState({ images, isOpen: true, isDisabled });
  }

  convertToViewerFormat = async (images) => {
    const procs = await PartnerApi.getProcedures();

    return images.map((image) => {
      const pr = procs.find((p) => p.proc_id === image.proc_id);
      const url = image.img_url || image.user_img_url;
      return {
        src: url,
        thumbnail: url,
        caption: pr.proc_name,
      };
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { isOpen, images, isDisabled } = this.state;

    return (
      <>
        <Button size="small" onClick={this.toggle} disabled={isDisabled}>
          <i className="fas fa-id-card" />
        </Button>
        {isOpen && (
          <PhotosViewer
            onClose={this.handleClose}
            imgs={images}
            showThumbnails
            isOpen
          />
        )}
      </>
    );
  }
}
